import { gql } from '@apollo/client';

import {
  SkipQuestionDocument,
  type SkipQuestionMutation,
  type SkipQuestionMutationVariables,
} from '../__generated__/documents';

/**
 * The same turn shape `addQuestionMessage` returns, minus the echoed `sent`
 * message — skipping produces no responder message to echo back.
 *
 * `@unmask` on every spread: see `add-question-message.gql.ts` — masking
 * strips `id` here too, so `client.readFragment` cannot identify the entity.
 */
if (false) {
  gql`
    mutation SkipQuestion($input: SkipQuestionInput!) {
      skipQuestion(input: $input) {
        isQuestionComplete
        isConversationOver
        surveyProgress
        replyFeedback {
          ...UnifiedMessage @unmask
        }
        reply {
          ...UnifiedMessage @unmask
        }
        nextQuestion {
          ...UnifiedQuestion @unmask
        }
        thankYouMessage {
          ...UnifiedMessage @unmask
        }
        actions {
          preActivationActionType
          preActivationActionData
          postActivationActionType
          postActivationActionData
        }
      }
    }
  `;
}

export const SKIP_QUESTION = SkipQuestionDocument;
export type { SkipQuestionMutation, SkipQuestionMutationVariables };
